/** Default translation key if missing the channel type */
export const DefaultBrandVoiceChannel = 'default';

/**
 * @deprecated - use BrandVoiceChannels instead
 */
export const BRAND_VOICE_CHANNEL_SETTING_TYPES = {
  BLOG: 'BLOG',
  CASE_STUDIES: 'CASE_STUDIES',
  EMAIL: 'EMAIL',
  PAGES: 'PAGES',
  PODCASTS: 'PODCASTS',
  SMS: 'SMS',
  SOCIAL: 'SOCIAL'
};

/**
 * @deprecated - use BrandVoiceSubChannels instead
 */
export const BRAND_VOICE_SUB_CHANNEL = {
  UNKNOWN: 'UNKNOWN',
  LINKEDIN: 'LINKEDIN',
  INSTAGRAM: 'INSTAGRAM',
  FACEBOOK: 'FACEBOOK',
  TWITTER: 'TWITTER'
};
export const BrandVoiceChannels = {
  BLOG: 'BLOG',
  CASE_STUDIES: 'CASE_STUDIES',
  EMAIL: 'EMAIL',
  PAGES: 'PAGES',
  PODCASTS: 'PODCASTS',
  SMS: 'SMS',
  SOCIAL: 'SOCIAL',
  UNKNOWN: 'UNKNOWN'
};
export const BrandVoiceSubChannels = {
  [BrandVoiceChannels.EMAIL]: {
    MARKETING_EMAIL: 'MARKETING_EMAIL',
    SALES_EMAIL: 'SALES_EMAIL'
  },
  [BrandVoiceChannels.SOCIAL]: {
    LINKEDIN: 'LINKEDIN',
    INSTAGRAM: 'INSTAGRAM',
    FACEBOOK: 'FACEBOOK',
    TWITTER: 'TWITTER'
  },
  [BrandVoiceChannels.UNKNOWN]: {
    UNKNOWN: 'UNKNOWN'
  }
};
export const BrandVoiceTones = ['Affectionate', 'Assertive', 'Authoritative', 'Businesslike', 'Casual', 'Cheerful', 'Colloquial', 'Commanding', 'Compassionate', 'Confident', 'Contemplative', 'Conversational', 'Corporate', 'Courteous', 'Cynical', 'Deferential', 'Doubtful', 'Earnest', 'Educational', 'Empathetic', 'Encouraging', 'Energetic', 'Enlightening', 'Enthusiastic', 'Excited', 'Fanciful', 'Formal', 'Friendly', 'Funny', 'Grave', 'Hopeful', 'Humorous', 'Immediate', 'Impartial', 'Incredulous', 'Informal', 'Informative', 'Insistent', 'Inspirational', 'Instructive', 'Introspective', 'Inviting', 'Ironical', 'Literal', 'Loving', 'Matter-of-fact', 'Mocking', 'Motivating', 'Neutral', 'Objective', 'Optimistic', 'Passionate', 'Playful', 'Polite', 'Positive', 'Pressing', 'Professional', 'Questioning', 'Quirky', 'Reflective', 'Relaxed', 'Respectful', 'Romantic', 'Sarcastic', 'Serious', 'Skeptical', 'Solemn', 'Straightforward', 'Sympathetic', 'Thoughtful', 'Unbiased', 'Understanding', 'Unemotional', 'Uplifting', 'Urgent', 'Warm', 'Whimsical', 'Witty'];
export const BrandVoicePersonalities = ['Adventurous', 'Authentic', 'Bold', 'Charismatic', 'Compassionate', 'Curious', 'Diverse', 'Down-to-earth', 'Driven', 'Dynamic', 'Eccentric', 'Edgy', 'Elegant', 'Helpful', 'Human', 'Innovative', 'Irreverent', 'Kind', 'Nurturing', 'Quirky', 'Rebellious', 'Relatable', 'Sophisticated', 'Supportive', 'Thoughtful', 'Trustworthy'];
export const BrandVoiceV3TaskStatuses = {
  CREATED: 'CREATED',
  IN_PROGRESS: 'IN_PROGRESS',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
};